import { render, staticRenderFns } from "./yeji-dialog.vue?vue&type=template&id=a099d0be"
import script from "./yeji-dialog.vue?vue&type=script&lang=js"
export * from "./yeji-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports